import React from 'react';

export function ShopsIcon({ className, width = 36, height = 36 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3977 1.75391C7.52429 1.75391 4.38379 4.8944 4.38379 8.76786V15.7818H6.13728V8.76786C6.13728 5.86321 8.49309 3.50739 11.3977 3.50739C14.3033 3.50739 16.6582 5.86321 16.6582 8.76786V15.7818H18.4117V8.76786C18.4117 4.8944 15.2712 1.75391 11.3977 1.75391Z"
        fill="#F4900C"
      />
      <path
        d="M2.63037 8.76758L4.38386 10.5211L6.13735 8.76758L7.89084 10.5211L9.64432 8.76758L11.3978 10.5211L13.1513 8.76758L14.9048 10.5211L16.6583 8.76758L18.4118 10.5211L20.1653 8.76758V28.9327H2.63037V8.76758Z"
        fill="#DD2E44"
      />
      <path
        d="M23.6722 6.1377C19.7987 6.1377 16.6582 9.27819 16.6582 13.1516V20.1656H18.4117V13.1516C18.4117 10.2461 20.7684 7.89118 23.6722 7.89118C26.5786 7.89118 28.9326 10.2461 28.9326 13.1516V20.1656H30.6861V13.1516C30.6861 9.27819 27.5456 6.1377 23.6722 6.1377Z"
        fill="#FFCC4D"
      />
      <path
        d="M14.9048 13.1514L16.6583 14.9049L18.4118 13.1514L20.1652 14.9049L21.9187 13.1514L23.6722 14.9049L25.4257 13.1514L27.1792 14.9049L28.9327 13.1514L30.6862 14.9049L32.4397 13.1514V33.3165H14.9048V13.1514Z"
        fill="#744EAA"
      />
    </svg>
  );
}
